import DropDownOptionProps from '@components/CaseDetails/ManageCaseDropDown/DropDownOptions/DropDownOptionProps';

export const sortDropDownOptions = (a: Partial<DropDownOptionProps>, b: Partial<DropDownOptionProps>): number => {
	if (!a.orderBy) return -1;
	if (!b.orderBy) return 1;

	return a.orderBy.localeCompare(b.orderBy);
};
